import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminHotelNavbarComponent } from '../../../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { ProductosService } from '../../../../services/productos.service';
import { TokenStorageService } from '../../../../services/token-storage.service';
import { NavbarComponent } from "../../../../components/navbar/navbar.component";

@Component({
  selector: 'app-crear-producto',
  imports: [AdminHotelNavbarComponent, FooterComponent, CommonModule, FormsModule, ReactiveFormsModule, NavbarComponent],
  templateUrl: './crear-producto.component.html',
  styleUrl: './crear-producto.component.css'
})
export class CrearProductoComponent implements OnInit {
  alojamientoId: string | null = null;
  alojamientoName: string | null = null;
  modoSeleccionado: string = 'individual';
  productoForm: FormGroup;
  cargandoErrores = false;
  listaErrores: string[] = [];
  imagenSeleccionada: File | null = null;
  archivoExcel: File | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private productosService: ProductosService,
    private tokenStorage: TokenStorageService) {
    this.productoForm = this.fb.group({
      nombre: [''],
      descripcion: [''],
      valor_neto: [''],
      porcentaje_impuestos: [''],
      stock: [''],
    });
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      const alojamientoIdParam = params.get('alojamientoId');
      console.log(alojamientoIdParam)
      if (alojamientoIdParam) {
        this.alojamientoId = alojamientoIdParam;
      } else {
        console.error('No se encontró alojamientoId en la URL');
      }
      const alojamientoNameParam = params.get('alojamientoName');
      if (alojamientoNameParam) {
        this.alojamientoName = alojamientoNameParam;
      } else {
        console.error('No se encontró alojamientoName en la URL');
      }
    });
  }

  crearProducto() {
    if (!this.alojamientoId) return;

    this.productosService.crearProducto(
      this.alojamientoId,
      this.productoForm.value,
      this.tokenStorage.getAccessToken() || ''
    ).subscribe({
      next: (res) => {
        console.log("Producto creado:", res);
        alert("✅ Producto creado con éxito");
        this.productoForm.reset();
        this.irAGestionarProducto();
      },
      error: (err) => {
        console.error("Error al crear producto:", err);
        alert("❌ Error al crear producto");
      }
    });
  }


  onFileSelected(event: any) {
    this.imagenSeleccionada = event.target.files[0];
  }

  onExcelFileSelected(event: any) {
    this.archivoExcel = event.target.files[0];
  }

  cargarProductosMasivos() {
    if (!this.archivoExcel || !this.alojamientoId) return;

    this.productosService.cargarProductosMasivos(this.alojamientoId, this.archivoExcel, this.tokenStorage.getAccessToken() || '')
      .subscribe({
        next: (data) => {
          console.log('Respuesta cargarProductosMasivos():', data);
          alert("✅ Productos creados con éxito");
          this.irAGestionarProducto();
        },
        error: (err) => {
          console.error('Error carga masiva:', err);
          alert("❌ Error al crear productos");
        }
      });
  }

  descargarErrores(key: string) {
    // Implementar descarga de archivo de errores
    alert('Descargando archivo de errores: ' + key);
  }

  irAGestionarProducto() {
    this.router.navigate(
      ['/admin-hotel/inventario/gestionar-productos'], {
      queryParams: {
        alojamientoId: this.alojamientoId,
        alojamientoName: this.alojamientoName,
      }
    });
  }
}